import { render } from "./AvatarUploadDialog.vue?vue&type=template&id=2c4b0eb8&scoped=true"
import script from "./AvatarUploadDialog.vue?vue&type=script&lang=js"
export * from "./AvatarUploadDialog.vue?vue&type=script&lang=js"

import "./AvatarUploadDialog.vue?vue&type=style&index=0&id=2c4b0eb8&lang=less&scoped=true"

import exportComponent from "C:\\Users\\PC\\AppData\\Local\\Temp\\tecs-enduser-release-cd96384e-20260902-1753\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4b0eb8"]])

export default __exports__